// 'dashboard' namespace — keys are prefixed 'dashboard.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'dashboard.greetingMorning': 'Доброе утро, {name}',
  'dashboard.greetingDay': 'Добрый день, {name}',
  'dashboard.greetingEvening': 'Добрый вечер, {name}',
  'dashboard.greetingAnon': 'Добро пожаловать',
  'dashboard.subtitle': 'Немного письма каждый день — и греческая рука становится увереннее.',
  'dashboard.subtitleNew': 'Тетрадь готова. Начнём с первого упражнения.',
  'dashboard.welcomeBadge': 'С чего начать',
  'dashboard.welcomeTitle': 'Перепишите первое письмо от руки',
  'dashboard.welcomeText':
    'Выберите короткое письмо уровня A2 и аккуратно перепишите его Apple Pencil — образец всё время перед глазами. После отправки приложение распознает почерк, вы проверите текст, и мы покажем каждую пропущенную букву, ударение и знак препинания.',
  'dashboard.welcomeCta': 'Выбрать первое письмо',
  'dashboard.continue': 'Продолжить писать',
  'dashboard.untitled': 'Без названия',
  'dashboard.updated': 'изменено {when}',
  'dashboard.localOnly': 'Только на устройстве',
  'dashboard.draftsPartial': 'Нет связи с сервером — показаны черновики с этого устройства.',
  'dashboard.pathTitle': 'Путь обучения',
  'dashboard.pathText':
    'Четыре шага от копирования к экзамену: сначала рука и глаз привыкают к образцу, затем память удерживает структуру письма, потом вы пишете своё — и, наконец, проверяете себя по времени.',
  'dashboard.step': 'Шаг {n}',
  'dashboard.path.copy': 'Переписывайте образцовые письма и тренируйте моторную память: буквы, ударения, пунктуацию.',
  'dashboard.path.recall': 'Изучите текст, скройте его и воспроизведите по памяти. Подсказки фиксируются.',
  'dashboard.path.free': 'Пишите своё письмо — на чистой странице или по заданию из библиотеки.',
  'dashboard.path.exam': 'Пробный экзамен A2: два задания, таймер, оценка по учебной шкале.',
  'dashboard.recent': 'Недавние работы',
  'dashboard.allHistory': 'Вся история',
  'dashboard.noRecent': 'Отправленных работ пока нет',
  'dashboard.noRecentText': 'Когда вы отправите первую работу, здесь появятся её результаты.',
  'dashboard.accuracyHint': 'Точность копирования по символам',
  'dashboard.progress': 'Прогресс',
  'dashboard.allProgress': 'Подробнее',
  'dashboard.statSessions': 'Работ',
  'dashboard.statWords': 'Слов',
  'dashboard.statMinutes': 'Минут',
  'dashboard.streak': '{n} {days} подряд с письмом',
  'dashboard.noStreak': 'Напишите что-нибудь сегодня, чтобы начать серию дней.',
  'dashboard.day.one': 'день',
  'dashboard.day.few': 'дня',
  'dashboard.day.many': 'дней',
  'dashboard.copyTrend': 'Точность копирования — последняя работа',
  'dashboard.trendDelta': '{delta} п.п. · последние работы: {n}',
  'dashboard.trendSingle': 'Первая оценённая копия',
  'dashboard.trendLabel': 'Точность копирования, последние работы ({n}): от {first} до {last}',
  'dashboard.noTrend': 'Здесь появится динамика точности после первой проверенной копии.',
};
const en: Record<string, string> = {
  'dashboard.greetingMorning': 'Good morning, {name}',
  'dashboard.greetingDay': 'Good afternoon, {name}',
  'dashboard.greetingEvening': 'Good evening, {name}',
  'dashboard.greetingAnon': 'Welcome',
  'dashboard.subtitle': 'A little writing every day makes a steadier Greek hand.',
  'dashboard.subtitleNew': 'Your notebook is ready. Let’s start with a first exercise.',
  'dashboard.welcomeBadge': 'Where to start',
  'dashboard.welcomeTitle': 'Copy your first letter by hand',
  'dashboard.welcomeText':
    'Pick a short A2 letter and copy it carefully with Apple Pencil — the model text stays in view. After you submit, the app reads your handwriting, you confirm the text, and we show every missed letter, accent and punctuation mark.',
  'dashboard.welcomeCta': 'Choose a first letter',
  'dashboard.continue': 'Continue writing',
  'dashboard.untitled': 'Untitled',
  'dashboard.updated': 'edited {when}',
  'dashboard.localOnly': 'On this device only',
  'dashboard.draftsPartial': 'Cannot reach the server — showing drafts from this device.',
  'dashboard.pathTitle': 'Learning path',
  'dashboard.pathText':
    'Four steps from copying to the exam: first hand and eye get used to the model, then memory holds the letter’s structure, then you write your own — and finally you test yourself against the clock.',
  'dashboard.step': 'Step {n}',
  'dashboard.path.copy': 'Copy model letters to build motor memory: letters, accents, punctuation.',
  'dashboard.path.recall': 'Study a text, hide it and write it from memory. Hints are recorded.',
  'dashboard.path.free': 'Write your own letter — on a blank page or from a library prompt.',
  'dashboard.path.exam': 'A2 mock exam: two tasks, a timer and a practice-rubric score.',
  'dashboard.recent': 'Recent work',
  'dashboard.allHistory': 'All history',
  'dashboard.noRecent': 'No submitted work yet',
  'dashboard.noRecentText': 'Once you submit your first attempt, its results appear here.',
  'dashboard.accuracyHint': 'Character-level copy accuracy',
  'dashboard.progress': 'Progress',
  'dashboard.allProgress': 'Details',
  'dashboard.statSessions': 'Attempts',
  'dashboard.statWords': 'Words',
  'dashboard.statMinutes': 'Minutes',
  'dashboard.streak': '{n} {days} of writing in a row',
  'dashboard.noStreak': 'Write something today to start a streak.',
  'dashboard.day.one': 'day',
  'dashboard.day.few': 'days',
  'dashboard.day.many': 'days',
  'dashboard.copyTrend': 'Copy accuracy — latest attempt',
  'dashboard.trendDelta': '{delta} pts · last {n} attempts',
  'dashboard.trendSingle': 'First evaluated copy',
  'dashboard.trendLabel': 'Copy accuracy over {n} attempts: from {first} to {last}',
  'dashboard.noTrend': 'Your accuracy trend appears after the first evaluated copy.',
};
export default { ru, en };
